import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './left-side.vue';

// Components
import LeftSideImageName from '../left-side-image-name/index';
import LeftSideTransactions from '../left-side-transactions/index';
import LeftSideLiveTransaction from '../left-side-live-transaction/index';

@Component({
    mixins: [template],
    components: {
        LeftSideImageName,
        LeftSideTransactions,
        LeftSideLiveTransaction
    }
})

export default class LeftSide extends Vue {

    @Prop(Object) readonly auctionDataParent!: object;

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/left-side/index.ts